import { BaseModel } from "./base";

export class Method extends BaseModel {
    public id: string;
    public priority: string;
    public url: string;

    constructor(json?: any) {
        super(json);
    }
}
